import React, { useEffect } from 'react';
import { KFLDialog } from '@kamstrup/kamstrup-frontend-library';
import DialogHeader from '../../shared/dialog/dialogHeader';
import useDialog from '../../shared/dialog/useDialog';
import DialogSection from '../../shared/dialog/dialogSection';
import useTx from '../../../modules/dialogs/transfer/useTx';
import { getPK } from '../../../modules/devices';
import Scrim from '../../shared/scrim';
import Translate from '../../shared/localization/localize';
import * as m from '../../../modules/dialogs/transfer/messages';

const TxDialogDevices: React.FC = () => {
  const { setDialog } = useDialog();
  const {
    info: { transferId: id, devices },
    getDevices,
    getDevicesStatus: status,
  } = useTx();

  useEffect(() => {
    if (!(devices?.length > 0) && id) getDevices(id);
  }, [devices, id]);

  const content = (
    <Scrim isActive={status.isFetching}>
      {status.errorMsg ? (
        <p>
          <Translate message={status.errorMsg}></Translate>
        </p>
      ) : (
        <div className="tx_details_box">
          <p>
            <Translate message={m.msgDeviceLabel}></Translate>
          </p>
          {devices?.map(getPK).map((d) => (
            <div key={'txDevice-' + d}>{d}</div>
          ))}
        </div>
      )}
    </Scrim>
  );

  return (
    <KFLDialog
      header={
        <DialogHeader
          title={<Translate message={m.msgHeaderDetails}></Translate>}
          fnCloseDialog={() => setDialog?.()}
        />
      }
      sections={[<DialogSection scrollable>{content}</DialogSection>]}
    />
  );
};

export default TxDialogDevices;
